// src/components/MobileMenu.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { getToken, isTokenValid, removeToken } from '../utils/jwtUtils';

function MobileMenu() {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const navigate = useNavigate();

    // Check if user is logged in
    useEffect(() => {
        const token = getToken();
        if (token && isTokenValid(token)) {
            setIsAuthenticated(true);
        } else {
            setIsAuthenticated(false);
        }
    }, []);

    const toggleDrawer = (open) => (event) => {
        if (
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return;
        }
        setDrawerOpen(open);
    };

    const handleLogout = () => {
        removeToken();
        setIsAuthenticated(false);
        setDrawerOpen(false);
        navigate('/');
    };

    const navigateTo = (path) => {
        navigate(path);
        setDrawerOpen(false);
    };

    return (
        <>
            <IconButton
                size="large"
                aria-label="mobile menu"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={toggleDrawer(true)}
                color="inherit"
            >
                <MenuIcon />
            </IconButton>
            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
                PaperProps={{
                    sx: {
                        width: '75vw',
                        bgcolor: '#fff',
                        color: '#333',
                    },
                }}
            >
                <List>
                    {isAuthenticated && (
                        <>
                            <ListItem>
                                <AccountCircleIcon fontSize="large" sx={{ mr: 1 }} />
                                <ListItemText primary="My Account" />
                            </ListItem>
                            <MenuItem onClick={() => navigateTo('/profile')}>
                                Edit Profile
                            </MenuItem>
                            <MenuItem onClick={() => navigateTo('/my-learning')}>
                                My Learning
                            </MenuItem>
                            <MenuItem onClick={() => navigateTo('/my-learning/certificates')}>
                                Certificates
                            </MenuItem>
                            <MenuItem onClick={handleLogout}>Log Out</MenuItem>
                            <Divider sx={{ my: 1 }} />
                        </>
                    )}
                    <MenuItem onClick={() => navigateTo('/certificate/verify')}>
                        Verify Cert
                    </MenuItem>
                    <MenuItem onClick={() => window.location.href = 'https://cloudsecnetwork.com/community'}>
                        Community
                    </MenuItem>
                    <MenuItem onClick={() => window.location.href = 'https://blog.cloudsecnetwork.com/'}>
                        Blog
                    </MenuItem>

                    {!isAuthenticated && (
                        <ListItem>
                            <Button
                                href="/signin"
                                variant="outlined"
                                sx={{
                                    width: '100%',
                                    color: '#333',
                                    borderColor: '#333',
                                    fontSize: '1rem',
                                    textTransform: 'none',
                                    '&:hover': {
                                        bgcolor: '#f5f5f5',
                                        borderColor: '#333',
                                    },
                                }}
                            >
                                Sign In
                            </Button>
                        </ListItem>
                    )}
                </List>
            </Drawer>
        </>
    );
}

export default MobileMenu;
